/* eslint-disable security/detect-non-literal-fs-filename */
import React from 'react';
import * as PropTypes from 'prop-types';
import classnames from 'classnames';
import {buildPageUrl} from '../utils/helpers/urlHelper';
import {useUser} from '../hooks/useUser';
import {useAnalytics} from '../hooks/useAnalytics';
import {IgniteCommonActions} from '../state/Analytics/AnalyticActions';

const PrintButton = ({ children, className, onClick, shouldOpenDetailsPage, tagName }) => {
  const { uuid } = useUser();
  const { actionCompleted } = useAnalytics();
  const detailsPageUrl = buildPageUrl({ uuid, type: 'details' });
  const ariaLabel = shouldOpenDetailsPage ? 'View Print Page' : 'Print Page';
  const Component = tagName || 'button';
  const classes = classnames('neuroPrintButton', className);

  const onClickFn = () => {
    onClick && onClick();
    if( shouldOpenDetailsPage ) {
      actionCompleted({ actionName: IgniteCommonActions.VIEW_DETAILS_PAGE_CLICKED });
      window.open( detailsPageUrl );
    } else {
      actionCompleted({ actionName: IgniteCommonActions.PRINT_BUTTON_CLICKED });
      window.print();
    }
  };

  return <Component className={ classes } aria-label={ ariaLabel } role='button' onClick={ onClickFn } tabIndex="0">
    { children }
  </Component>;
};

PrintButton.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  shouldOpenDetailsPage: PropTypes.bool,
  tagName: PropTypes.string
};

export default PrintButton;
